
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/for-foretag",
      function () {
        return require("private-next-pages/for-foretag.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/for-foretag"])
      });
    }
  